module.exports = __webpack_public_path__ + "files/f94d5e5102359961c44a1da1b58d37c9.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/Roboto-regular.woff
// module id = 632
// module chunks = 60